import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'post'

export default class OspreyOffersPropagate extends BaseAction {
    constructor(dataKey) {
        const id = 'e409c543-a844-4186-bfd6-16308f71256a'
        const path = `/${resource}/propagate`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = () => true
    }

    propagate(siloId = null) {
        if (siloId) {
            this.path = `/${resource}/propagate/${siloId}`
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-propagate.js